import { get, post, put, del } from "./request";

/*
 * 管理员登录
 */
export const adminLoginApi = (data: IAdminLoginForm) => {
  return post<IAdminLoginRes>("/admin/admin/login", data);
};

/*
 * 管理员信息
 */
export const adminInfoApi = () => {
  return get<IAdmin>("/admin/admin/info");
};

/*
 * 租户信息
 */
export const currentTenantInfoApi = () => {
  return get<ITenant>("/admin/tenant/info");
};

/*
 * 租户信息
 */
export const tenantInfoApi = (tenantId: number) => {
  return get<ITenant>(`/admin/tenant/${tenantId}`);
};

/*
 * 租户列表 获取分页参数
 */
export const tenantListApi = (params: ITenantPageParams) => {
  return get<IBasePageResponse<ITenant>>("/admin/tenant",params);
};


/*
 * 新增租户
 */
export const tenantCreateApi = (data: ITenantForm) => {
  return post("/admin/tenant", data);
};

/*
 * 更新租户
 */
export const tenantUpdateApi = (data: ITenantForm) => {
  return put("/admin/tenant", data);
};

/*
 * 删除租户
 */
export const tenantDeleteApi = (tenantId: number) => {
  return del(`/admin/tenant/${tenantId}`);
};

/*
 * 上传文件
 */
export const uploadFileApi = (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  return post<string>("/admin/sys/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

/*
 * 获取租户管理员账户
 */
export const tenantAdminListApi = (tenantId: number) => {
  return get<IAdmin[]>(`/admin/admin/tenant/${tenantId}`);
};

/*
 * 新增租户管理员账户
 */
export const adminCreateApi = (data: IAdminForm) => {
  return post("/admin/admin", data);
};

/*
 * 更新租户管理员账户
 */
export const adminUpdateApi = (data: IAdminForm) => {
  return put("/admin/admin", data);
};

/*
 * 删除租户管理员账户
 */
export const adminDeleteApi = (adminId: number) => {
  return del(`/admin/admin/${adminId}`);
};

/*
 * 轮播图列表
 */
export const bannerListApi = () => {
  return get<IBanner[]>("/admin/banner");
};


/*
 * 新增轮播图
 */
export const bannerCreateApi = (data: IBannerForm) => {
  return post("/admin/banner", data);
};

/*
 * 更新轮播图
 */
export const bannerUpdateApi = (data: IBannerForm) => {
  return put("/admin/banner", data);
};

/*
 * 删除轮播图
 */
export const bannerDeleteApi = (bannerId: number) => {
  return del(`/admin/banner/${bannerId}`);
};

/*
 * 部门列表
 */
export const departmentListApi = (params: IDepartmentPageParams) => {
  return get<IBasePageResponse<IDepartment>>("/admin/department", params);
};

/*
 * 新增部门
 */
export const departmentCreateApi = (data: IDepartmentForm) => {
  return post("/admin/department", data);
};

/*
 * 更新部门
 */
export const departmentUpdateApi = (data: IDepartmentForm) => {
  return put("/admin/department", data);
};

/*
 * 删除部门
 */
export const departmentDeleteApi = (departmentId: number) => {
  return del(`/admin/department/${departmentId}`);
};

/*
 * 简单部门列表
 */
export const simpleDepartmentListApi = () => {
  return get<IDepartment[]>("/admin/department/simple");
};

/*
 * 疾病列表
 */
export const diseaseListApi = (params: IDiseasePageParams) => {
  return get<IBasePageResponse<IDisease>>("/admin/disease", params);
};

/*
 * 新增疾病
 */
export const diseaseCreateApi = (data: IDiseaseForm) => {
  return post("/admin/disease", data);
};

/*
 * 更新疾病
 */
export const diseaseUpdateApi = (data: IDiseaseForm) => {
  return put("/admin/disease", data);
};

/*
 * 删除疾病
 */
export const diseaseDeleteApi = (diseaseId: number) => {
  return del(`/admin/disease/${diseaseId}`);
};

/*
 * 医生列表
 */
export const doctorListApi = (params: IDoctorPageParams) => {
  return get<IBasePageResponse<IDoctor>>("/admin/doctor", params);
};

/*
 * 新增医生
 */
export const doctorCreateApi = (data: IDoctorForm) => {
  return post("/admin/doctor", data);
};

/*
 * 更新医生
 */
export const doctorUpdateApi = (data: IDoctorForm) => {
  return put("/admin/doctor", data);
};

/*
 * 简单医生列表
 */
export const doctorSimpleListApi = () => {
  return get<IDoctor[]>("/admin/doctor/simple");
};

/*
 * 删除医生
 */
export const doctorDeleteApi = (doctorId: number) => {
  return del(`/admin/doctor/${doctorId}`);
};

/*
 * 获取医生详情
 */
export const doctorInfoApi = (doctorId: number) => {
  return get<IDoctor>(`/admin/doctor/${doctorId}`);
};

/*
 * 获取医生详情
 */
export const doctorDiseaseInfoApi = (form: IDoctorDiseaseForm) => {
  return post<IDoctor>(`/admin/doctor/disease`, form);
};


/*
 * 用户列表
 */
export const userListApi = (params: IUserPageParams) => {
  return get<IBasePageResponse<IUser>>("/admin/user", params);
};

/*
 * 表单列表
 */
export const formListApi = (params: IFormPageParams) => {
  return get<IBasePageResponse<IForm>>("/admin/form", params);
};

/*
 * 表单处理
 */
export const formHandleApi = (data: IFormHandleForm) => {
  return put("/admin/form", data);
};


/*
 * 获取医生关联疾病
 */
export const doctorDiseaseListApi = (doctorId: number) => {
  return get<IDisease[]>(`/admin/disease/doctor/${doctorId}`);
};



/*
 * 今日新增授权 可更改接口日期
 */
export const todayUserListApi = () => {
  return get<IUser[]>(`/admin/user/today`);
};


/*
 * 今日新增表单 可更改接口日期
 */
export const todayFormListApi = () => {
  return get<IForm[]>(`/admin/form/today`);
};



/*
 * 未处理表单 可更改接口日期
 */
export const unhandledFormListApi = () => {
  return get<IForm[]>(`/admin/form/unhandled`);
};

/*
 * 修改密码
 */
export const passwordResetApi = (data: IPasswordResetForm) => {
  return put("/admin/admin/password", data);
};

/*
 * 处理用户
 */
export const userHandleApi = (data: IUserHandleForm) => {
  return put("/admin/user/handle", data);
};
